import React from "react";
import styled from "@emotion/styled";
import PreviewSection from "../components/PreviewSection";
import { DataChip } from "@atlas-int/ui";
import {
  spacing,
  fontSize,
  fontFamily,
  fontWeight,
  text,
} from "@atlas-int/tokens";

// ─── Styled helpers ──────────────────────────────────────────────────────────

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing[4]};
  align-items: center;
  margin-bottom: ${spacing[6]};
`;

const GroupLabel = styled.h4`
  font-family: ${fontFamily.base};
  font-size: ${fontSize.base};
  font-weight: ${fontWeight.semibold};
  color: ${text.secondary};
  margin: ${spacing[6]} 0 ${spacing[2]} 0;
`;

// ─── Constants ───────────────────────────────────────────────────────────────

const dataTypes = [
  "rankings",
  "bilateral",
  "unilateral",
  "product",
  "classification",
  "product_space",
];

const classifications = ["HS92", "HS12", "HS22", "SITC", "Services"];

// ─── Component ───────────────────────────────────────────────────────────────

const DataChipSection: React.FC = () => {
  return (
    <PreviewSection
      id="datachip"
      title="DataChip"
      description="Colored chip indicators for data types and classification systems."
    >
      {/* Data Type chips */}
      <GroupLabel>Data Types</GroupLabel>
      <ChipRow>
        {dataTypes.map((type) => (
          <DataChip key={type} label={type} chipType="dataType" />
        ))}
      </ChipRow>

      {/* Classification chips */}
      <GroupLabel>Classifications</GroupLabel>
      <ChipRow>
        {classifications.map((cls) => (
          <DataChip key={cls} label={cls} chipType="classification" />
        ))}
      </ChipRow>
    </PreviewSection>
  );
};

export default DataChipSection;
